import { render, staticRenderFns } from "./SelectCustomerModal.vue?vue&type=template&id=5f8c83ef&scoped=true&"
import script from "./SelectCustomerModal.vue?vue&type=script&lang=js&"
export * from "./SelectCustomerModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectCustomerModal.vue?vue&type=style&index=0&id=5f8c83ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c83ef",
  null
  
)

export default component.exports